import React, { useState, useEffect, useRef } from "react";
import Chart from "react-google-charts";
import {
  getUniversityList,
  getInstituteList,
  getRecruiterList,
  getEmployerList,
  getTotalEnquiry,
} from "../Actions/AdminAction";
import { token } from "../Actions/AuthAction";
import { getJobsList } from "../Actions/JobAction";
import { listDrive } from "../Actions/DriveAction";
import { allCandidatesList } from "../Actions/CandidateAction";
import { Link } from "react-router-dom";
import Loader from "../Common/Loader";
import config from "../../config";
import { getNotification, selectSector, GetSkill, GetCourses, selectState } from "../Actions/CommonAction";

const AdminDashboard = ({ profileCompletetionStatus }) => {
  const [totalUniversity, setTotalUniversity] = useState(0);
  const [totalIntitution, setTotalInstitution] = useState(0);
  const [totalRecruiter, setTotalRecruiter] = useState(0);
  const [totalEmployer, setTotalEmployer] = useState(0);
  const [totalJobs, setTotalJobs] = useState(0);
  const [totalDrive, setTotalDrive] = useState(0);
  const [totalCandidates, setTotalCandidates] = useState(0);
  const [totalEnquiry, setTotalEnquiry] = useState(0);
  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState([]);

  const [totalsector, setTotalSector] = useState(0);
  const [totalskill, setTotalSkill] = useState(0);
  const [totalcourse, setTotalCourse] = useState(0);
  const [totalstates, setTotalState] = useState(0);

  useEffect(() => {
    getUniversityList({
      page: "1",
      search: "",
      status: "",
      city: "",
      state: "",
      limit: "",
    }).then((res) => {
      if (res.status) {
        setTotalUniversity(res.totaldata);
      } else {
        if (res.error.errorInfo[0] == "08006") {
          alert(
            'could not connect to server: Connection refused\n\tIs the server running on host "216.48.177.88" and accepting\n\tTCP/IP connections on port 5432?'
          );
        } else {
          alert("Something went wrong");
        }
      }
    });

    getInstituteList({
      key: token(),
      page: "1",
      search: "",
      status: "",
      city: "",
      state: "",
      limit: "",
    }).then((res) => {
      setTotalInstitution(res.totaldata);
    });

    getRecruiterList({
      page: "1",
      search: "",
      status: "",
      city: "",
      state: "",
      limit: "",
    }).then((res) => {
      setTotalRecruiter(res.totaldata);
    });

    getEmployerList({
      page: "1",
      search: "",
      status: "",
      city: "",
      state: "",
      limit: "",
    }).then((res) => {
      setTotalEmployer(res.totaldata);
    });

    getJobsList({
      page: "1",
      token: token(),
      recruiterid: "",
      employeeid: "",
      sector: "",
    }).then((res) => {
      //alert();
      if (res.status) {
        setTotalJobs(res.totaldata);
      }
    });

    listDrive({
      loginusertoken: token(),
      page: "1",
      startdate: "",
      enddate: "",
      instid: "",
      venuestatus: "",
      drivetype: "",
      drivestatus: "",
    }).then((res) => {
      if (res.status) {
        setTotalDrive(res.totaldata);
      }
    });

    getTotalEnquiry({ token: token() }).then((res) => {
      if (res.status) {
        setTotalEnquiry(res.totaldata);
      }
    });


    selectSector({ status: "" }).then((res) => {
      if (res.status) {
        setTotalSector(res.data.length);
      }
    });

    GetSkill({ status: "" }).then((res) => {
      if (res.status) {
        setTotalSkill(res.data.length);
      }
    });

    GetCourses({ status: "" }).then((res) => {
      if (res.status) {
        setTotalCourse(res.data.length);
      }
    });

    selectState({ status: "" }).then((res) => {
      if (res.status) {
        setTotalState(res.data.length);
      }
    });

    allCandidatesList({
      key: token(),
      page: "1",
      search: "",
      status: 0,
      city: "",
      instid: "",
      limit: 5,
      skill: [],
      state: "",
      uniid: "",
    }).then((res) => {
      setTotalCandidates(res.totaldata);
      setLoading(false);
    });

    getNotification({
      loginusertoken: token(),
      page: "1",
      readstatus: "",
    }).then((res) => {
      setNotification(res.data);
    });
  }, []);

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div class="row mt-4">
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/universitylist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Universities
                  <span class="d-block text-danger mt-4">
                    {totalUniversity}
                  </span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fas fa-university"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/institutionlist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Partner Consultant / Institutions
                  <span class="d-block text-danger mt-4">
                    {totalIntitution}
                  </span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fas fa-building"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/recruiterlist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Recruiters
                  <span class="d-block text-danger mt-4">{totalRecruiter}</span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fas fa-user-secret"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/employerlist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Employers
                  <span class="d-block text-danger mt-4">{totalEmployer}</span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fas fa-graduation-cap"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/listjob" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Jobs
                  <span class="d-block text-danger mt-4">{totalJobs}</span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fa fa-handshake"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>

        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/drivelist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Drives
                  <span class="d-block text-danger mt-4">{totalDrive}</span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fa fa-address-card"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/candidateslist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Candidates
                  <span class="d-block text-danger mt-4">
                    {totalCandidates}
                  </span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fas fa-users"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/listEnquiry" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Enquiry
                  <span class="d-block text-danger mt-4">{totalEnquiry}</span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fas fa-question-circle"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/mastersectorslist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Sectors
                  <span class="d-block text-danger mt-4">{totalsector}</span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  {/* <i class="d-block text-danger dashboardiconimg fas fa-question-circle"></i> */}
                  <img src={`${config.DOMAIN_URL}/assets/img/sectors.png`} className="d-block text-danger dashboardiconimg"/>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/masterskillslist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Skills
                  <span class="d-block text-danger mt-4">{totalskill}</span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fas fa-question-circle"></i>
                  {/* <img src={`${config.DOMAIN_URL}/assets/img/skills1.png`} className="d-block text-danger dashboardiconimg"/> */}
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/mastercourseslist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Courses
                  <span class="d-block text-danger mt-4">{totalcourse}</span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  {/* <i class="d-block text-danger dashboardiconimg fas fa-question-circle"></i> */}
                  <img src={`${config.DOMAIN_URL}/assets/img/courses.png`} className="d-block text-danger dashboardiconimg"/>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/masterstateslist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  States
                  <span class="d-block text-danger mt-4">{totalstates}</span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  {/* <i class="d-block text-danger dashboardiconimg fas fa-question-circle"></i> */}
                  <img src={`${config.DOMAIN_URL}/assets/img/states.png`} className="d-block text-danger dashboardiconimg"/>
                </h2>
              </div>
            </Link>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-md-7">
          <div class="card table_card mb-4">
            <h4 class="table_heading position-relative">Graph Analytics</h4>
            <div class="card-body">
              <Chart
                height={350}
                chartType="AreaChart"
                loader={<div>Loading Chart</div>}
                data={[
                  ["Campus Rozagr Analysis", "Total"],
                  ["Universities", totalUniversity],
                  ["Institutions", totalIntitution],
                  ["Recuitors", totalRecruiter],
                  ["Employers", totalEmployer],
                  ["Candidates", totalCandidates],
                ]}
                options={{
                  title: "Campus Rozgar Data Analysis",
                  chartArea: { width: "70%" },
                  colors: ["#e62e2d", "#ffab91"],
                  hAxis: {
                    title: "Total",
                    minValue: 0,
                  },
                  vAxis: {
                    title: "Campus Rozgar",
                  },
                }}
                legendToggle
              />
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <div class="card table_card mb-4">
            <div className="d-flex justify-content-between">
              <h4 class="table_heading position-relative">Notification</h4>
              <Link to="/notification" className="mr-4 mt-2">View All</Link>
            </div>
            <div class="card=body">
              <div class="notification">
                <ul>
                  {notification !== undefined &&
                    notification.map((item) => (
                      <li>
                        <div class="d-flex justify-content-start">
                          <div class="ml-3">
                            <span className="unreadnotification">
                              {item.notificationtitle}
                            </span>

                            <p>
                              {item.description} (
                              <strong>{item.createddate}</strong>)
                            </p>
                          </div>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AdminDashboard;
